var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFC900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.818 5.63672L6.18164 6.72763L6.7271 10.5458H7.818H9.45437L11.6362 11.6367L13.2726 11.0913V6.72763L12.7271 7.27308L10.5453 6.72763L7.818 5.63672Z",
    fill: "#FFC900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5V14.5",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5V11",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.4998C6.96732 6.04173 7.59562 5.78516 8.25 5.78516C8.90438 5.78516 9.53268 6.04173 10 6.4998C10.4673 6.95787 11.0956 7.21444 11.75 7.21444C12.4044 7.21444 13.0327 6.95787 13.5 6.4998",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.9998C6.96732 10.5417 7.59562 10.2852 8.25 10.2852C8.90438 10.2852 9.53268 10.5417 10 10.9998C10.4673 11.4579 11.0956 11.7144 11.75 11.7144C12.4044 11.7144 13.0327 11.4579 13.5 10.9998",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCircle);
export default __webpack_public_path__ + "static/media/flag-circle.d2d089ff77cea3083983827126cccc70.svg";
export { ForwardRef as ReactComponent };